import generalSection from "../_section/section.class";
import {userProofOfAddressUpload, adminProofOfAddressUpload} from "./upload";
import dayjs from "dayjs";
import ApplicationForm from "./ApplicationForm";
import DataForm from "./DataForm";
import problem from "../_section/section-problem.class";

export class userProofOfAddressSection extends generalSection {
    constructor(request, mortgage, props, statementUploadFactory = null) {
        super(request, mortgage, props, statementUploadFactory ?? userProofOfAddressUpload);
        // Add missing date error

    }
}

export class adminProofOfAddressSection extends userProofOfAddressSection {
    constructor(request, mortgage, props) {
        super(request, mortgage, props, adminProofOfAddressUpload);
        this.ApplicationForm = ApplicationForm
        this.DataForm = DataForm
        this.sortByDateProp('documentDate');
        this.activeUpload = this.uploads.find(u=> u.allValuesAnswered && u.isVerifiable)
        this.setProblems(this.getProblems())

    }
    getProblems (){
        const problems =  this.problemsList.singleUploadUserProblems();
        if (!problems.length){
            // Address Mismatch
            const applicationAddress = this.mortgage[`applicant${this.applicant}`].personal.addressCurrent
            const removeFormattedAddress = (add)=> add ? add.replace(/[^a-zA-Z0-9\s]/g, '').toLowerCase() : null;
            if (this.address && applicationAddress && removeFormattedAddress(this.address) !== removeFormattedAddress(applicationAddress)) {

                problems.push(new problem({
                    type: 'BUNDLE',
                    title: 'Data Mismatch',
                    reason: 'Application doesnt match the upload',
                    uploadIDs: [this.activeUpload.id],
                    message: `Reformat the application address to match POA`,
                }))
            }

            // Stamp Missing
            if (this.activeUpload && !this.activeUpload?.props.upload.stampedOn) {
                problems.push(new problem({
                    type: 'BUNDLE',
                    title: 'Missing Stamp',
                    message: `The document is not stamped`,
                    uploadIDs: [this.activeUpload.id]
                }));
            }
        }
        return  problems
    }

    get address() {
        return this?.activeUpload?.values?.address
    }
    get documentDate() {
        return this?.activeUpload?.values?.documentDate
    }
    calcErrors() {


        // are there multiple addresses?
        let uploads = this.activeUploads
        const uploadsWithAddress = uploads.filter(u=> u.allValuesAnswered)
        const multipleAddress = [...new Set(uploadsWithAddress.map(u => u.values.address))]
        if (multipleAddress.length > 1) {
            this.errors.push(`Multiple addresses found`);
        }


        // does the address match the application address?
        const thisAddress = this.address
        const applicationAddress = this.mortgage[`applicant${this.applicant}`].personal.addressCurrent
        if (this.activeUpload && !this.activeUpload.allValuesAnswered){
            this.errors.push(`Missing upload data`);
        }

        if (thisAddress && applicationAddress && thisAddress !== applicationAddress) {
            this.errors.push(`Mismatch with application address`);
        }

        // is it stamped?
        if (this.activeUpload && !this.activeUpload?.props.upload.stampedOn){
            this.errors.push(`Not Stamped`);
        }

        // is it expired?
        if (this.activeUpload?.range?.to?.date.isBefore(dayjs())) {
            this.errors.push(`Document expired`);
        }

    }

    getSectionSummary = ()=>{
        return [
            {
                name: this.personalTitle,
                tags: [{
                    name: 'Address',
                    value: this.address
                },
                    {
                        name: 'Document Date',
                        value: this.documentDate
                    }]
            }
        ]
    }
}